import { isAdmin } from '../actionHelper';
import { Carriers } from '../constants/carriers';
import { USStates } from '../constants/countryStates';
import { DebitsValue, RateClass } from '../constants/decision';
import { Products } from '../constants/products';
import { RiderNames } from '../constants/rider';
import { UserOrganization } from '../constants/userOrganization';
import { ProductConfig } from './productConfig';

export class AmeritasIUL extends ProductConfig {
  getCarrier(): Carriers {
    return Carriers.AMERITAS;
  }
  getProduct(): Products {
    return Products.IUL;
  }
  availableToOrganization(org: UserOrganization): boolean {
    return [
      UserOrganization.AMERITAS,
      UserOrganization.ETHOS,
      UserOrganization.INTEGRA,
    ].includes(org);
  }
  getColor(): string {
    return 'Indigo';
  }
  showPolicyCombined(roles: string[], org: string) {
    return (
      org === UserOrganization.AMERITAS ||
      (isAdmin(roles) && org === UserOrganization.ETHOS)
    );
  }
  showPercentageAddition(rateClass: string | undefined): boolean {
    return rateClass === RateClass.STANDARD;
  }
  showDebits(rateClass: string | undefined): boolean {
    return rateClass === RateClass.STANDARD;
  }
  hasPercentageAddition(): boolean {
    return true;
  }
  hasTableRating(): boolean {
    return true;
  }
  getDebitsList(): DebitsValue[] {
    return [
      DebitsValue.Debits_0,
      DebitsValue.Debits_25,
      DebitsValue.Debits_50,
      DebitsValue.Debits_75,
      DebitsValue.Debits_100,
      DebitsValue.Debits_125,
      DebitsValue.Debits_150,
      DebitsValue.Debits_175,
      DebitsValue.Debits_200,
      DebitsValue.Debits_225,
      DebitsValue.Debits_250,
    ];
  }
  medicalExamAvailable(): boolean {
    return true;
  }
  ETIAvailable(): boolean {
    return true;
  }
  hasStandardPlusRating(_flags: any): boolean {
    return true;
  }
  showTobaccoForPreferred(_flags: any): boolean {
    return true;
  }
  getUnderWritableRiders(state: string): string[] {
    switch (state) {
      case USStates.CA:
        return [
          RiderNames.CHRONIC_ILLNESS,
          RiderNames.CRITICAL_ILLNESS,
          RiderNames.WAIVER_OF_SPECIFIED_PREMIUM,
          RiderNames.ACCIDENTAL_DEATH,
          // terminal illness is always available
          // RiderNames.TERMINAL_ILLNESS,
        ];
      default:
        return [
          RiderNames.ACCIDENTAL_DEATH,
          RiderNames.WAIVER_OF_SPECIFIED_PREMIUM,
          RiderNames.CARE4LIFE,
          // terminal illness is non underwritable; it follows CARE4LIFE via mutual exclusivity
          // RiderNames.TERMINAL_ILLNESS,
        ];
    }
  }
  public getRiderExclusivityRules(
    state: string,
  ): { sourceRider: string; targetRider: string; inverse: boolean }[] {
    if (state === USStates.CA) {
      return [];
    }
    return [
      {
        sourceRider: RiderNames.CARE4LIFE,
        targetRider: RiderNames.TERMINAL_ILLNESS,
        inverse: true,
      },
    ];
  }

  public TRLAvailable(): boolean {
    return true;
  }
}
